module.exports = __webpack_public_path__ + "static/media/002.778786a8.jpg";